export var AssetsGroupType;
(function (AssetsGroupType) {
    AssetsGroupType["POPULAR"] = "POPULAR";
    AssetsGroupType["US_STRATEGIC"] = "US_STRATEGIC";
    AssetsGroupType["TOP_GROWING"] = "TOP_GROWING";
    AssetsGroupType["TOP_DECLINING"] = "TOP_DECLINING";
})(AssetsGroupType || (AssetsGroupType = {}));
//# sourceMappingURL=asset.js.map